import { render, staticRenderFns } from "./InfoPointsForm.vue?vue&type=template&id=9ae348e2&scoped=true&"
import script from "./InfoPointsForm.vue?vue&type=script&lang=js&"
export * from "./InfoPointsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae348e2",
  null
  
)

export default component.exports